export default __webpack_public_path__ + "static/kiln-2-e5e0bf7644a7109d58ed5b5d217d7a14.jpg";